import Loader from '@/components/loader/loader-component';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import SelectSearch from '@/components/react-hook-form-inputs/select-search/select-search-component';
import { requiredValidationMessage } from '@/utils/validations';
import { useFieldArray, useFormContext } from 'react-hook-form';
import {
  MdOutlineAddCircleOutline,
  MdRemoveCircleOutline,
} from 'react-icons/md';
import Styled from './quote-module-form-style';

const mainContainerStyle = {
  gap: '12px',
  marginLeft: '12px',
  marginTop: '-24px',
};

/**
 *
 * @returns {JSX.Element} - form component
 */
const QuoteModuleForm = () => {
  const { watch, control, setValue, formState, getValues } = useFormContext();
  const moduleType = watch('type');

  const { fields, remove, insert } = useFieldArray({
    control,
    name: 'options', // unique name for your Field Array
  });

  if (formState.isLoading) {
    return <Loader loading />;
  }

  return (
    <Styled.RowStyle>
      <SelectSearch
        name="type"
        header="Quoting Module Type"
        options={[
          { value: 'price', label: 'Price' },
          { value: 'details', label: 'Details' },
        ]}
        placeholder="Select Quoting Module Type"
        registerOptions={{
          required: requiredValidationMessage,
        }}
      />

      <Input
        disabled={false}
        label="Module Title"
        placeholder="Module Name"
        name="title"
        registerOptions={{
          required: requiredValidationMessage,
        }}
      />
      <Input
        disabled={false}
        label="Module Description"
        placeholder="Module Description"
        name="description"
        registerOptions={{
          required: requiredValidationMessage,
        }}
      />
      {moduleType === 'details' && (
        <Styled.OptionsDiv>
          <Styled.DropdownHeading>Dropdown options</Styled.DropdownHeading>

          {fields.map((item, index) => (
            <Styled.OptionsRow key={`options-${item.id}`}>
              <Styled.RadioButton
                options={[
                  {
                    value: true,
                    label: '',
                  },
                ]}
                mainContainerStyle={mainContainerStyle}
                name={`options.${index}.defaultOption`}
                registerOptions={{
                  onChange: (v) => {
                    if (v.target.value === 'true') {
                      const defaultOption = getValues('options').map(
                        (options, i) => {
                          if (i === index) {
                            return {
                              value: options.value,
                              defaultOption: true,
                            };
                          }
                          return {
                            value: options.value,
                            defaultOption: false,
                          };
                        },
                      );
                      setValue('options', defaultOption);
                    }
                  },
                }}
              />
              <Input
                placeholder="option"
                disabled={index === 0}
                required={{
                  required: 'Please Add 1 or more Options',
                  pattern: {
                    message: 'Field cannot be empty',
                  },
                }}
                className="input"
                inputStyle={{
                  width: fields.length > 1 && index !== 0 ? '100%' : '90%',
                }}
                name={`options.${index}.value`}
              />
              {fields.length > 1 && index !== 0 && (
                <Styled.DeletePartNumbCol>
                  <MdRemoveCircleOutline
                    size={24}
                    onClick={() => remove(index)}
                  />
                </Styled.DeletePartNumbCol>
              )}
            </Styled.OptionsRow>
          ))}
          <Styled.AddOptionButton
            onClick={() => {
              insert(fields.length, { value: '' });
            }}
          >
            <MdOutlineAddCircleOutline size={24} /> Add Option
          </Styled.AddOptionButton>
        </Styled.OptionsDiv>
      )}
    </Styled.RowStyle>
  );
};

export default QuoteModuleForm;
